<template>
  <div class="section-title d-flex justify-space-between align-center">
    <div class="text-subtitle-1 d-inline-block">
      <slot>{{ title }}</slot>
    </div>
    <div class="text-subtitle-1 d-flex flex-end align-baseline">
      <div class="d-inline-block">
        <slot name="extra-action"></slot>
      </div>
      <div v-if="search" class="d-inline-block">
        <v-tooltip
          top
          open-delay="200"
        >
          <template #activator="{ on, attrs }">
            <v-icon
              v-on="on"
              v-bind="attrs"
              @click="showSearch = !showSearch"
            >mdi-magnify</v-icon>
          </template>
          <template #default>
            Tìm kiếm
          </template>
        </v-tooltip>
        <v-text-field
          v-if="showSearch"
          label="Tìm kiếm"
          hide-details
          dense
          color="primary"
          @click:prepend="showSearch = !showSearch"
          :value="searchText"
          @input="$emit('input', $event)"
          :autofocus="showSearch"
          class="d-inline-block"
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    title: {
      type: String,
      default: '',
    },
    search: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    showSearch: false,
    searchText: '',
  })
}
</script>

<style scoped>
.section-title {
  border-bottom: 1px solid var(--v-primary-lighten5);
  max-width: 500px;
  height: 37px;
}
</style>
